import React, { useCallback, useEffect, useMemo, useState } from "react";

import { MultiPartSliderOption } from "../MultiPartSlider";

type Props = {
  updateValuesForSlide: (index: number, delta: number, left: number) => void;
  finishedSettingValues: () => void;
  item: MultiPartSliderOption;
  index: number;
  left: number;
};

export const MultiPartSliderHandle = (props: Props) => {
  // const [dragInfo, setDragInfo] = useState({
  //     isDragging: false,
  //     origin: { x: 0, y: 0 },
  //     left:0
  //     // translation: startingPosition,
  //     // lastTranslation: startingPosition,
  //   })

  //   const { isDragging } = dragInfo
  //   const handleMouseDown = ({ clientX, clientY }) => {
  //     if (!isDragging)
  //       setDragInfo({
  //         ...dragInfo,
  //         isDragging: true,
  //         origin: { x: clientX, y: clientY },
  //         left:props.left
  //       })
  //   }

  //   const handleMouseMove = ({ clientX, clientY }) => {
  //

  //     if (isDragging) {
  //         const { origin, } = dragInfo
  //         const delta = clientX - (origin.x)
  //
  //         //   const { origin, lastTranslation } = dragInfo
  //     //   setDragInfo({
  //     //     ...dragInfo,
  //     //     translation: {
  //     //       x: Math.abs(clientX - (origin.x + lastTranslation.x)),
  //     //       y: Math.abs(clientY - (origin.y + lastTranslation.y)),
  //     //     },
  //     //   })

  //       props.updateValuesForSlide(props.index, delta, props.left + delta)
  //     }
  //   }

  //   const handleMouseUp = ({ clientX, clientY }) => {
  //     if (isDragging) {
  //         const delta = clientX - (dragInfo.origin.x)
  //         props.updateValuesForSlide(props.index, delta, props.left + delta)
  //

  //     //   const { translation } = dragInfo
  //       setDragInfo({
  //         ...dragInfo,
  //         isDragging: false,
  //         //lastTranslation: { x: translation.x, y: translation.y },
  //       })
  //     }
  //   }

  // const { innerHeight, innerWidth } = window
  const startingPosition = { x: props.left, y: 0 };

  const [dragInfo, setDragInfo] = useState({
    isDragging: false,
    origin: { x: 0, y: 0 },
    translation: startingPosition,
    lastTranslation: startingPosition
  });

  const { isDragging } = dragInfo;

  // const handleMouseDown =  useCallback(({ clientX, clientY }) => {
  const handleMouseDown = ({ clientX, clientY }) => {
    if (!isDragging)
      setDragInfo({
        ...dragInfo,
        isDragging: true,
        origin: { x: clientX - props.left, y: clientY }
      });
  };

  // }, [dragInfo, isDragging, props.left])

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (isDragging) {
      const { origin, lastTranslation } = dragInfo;

      setDragInfo({
        ...dragInfo,
        translation: {
          x: Math.abs(e.clientX - origin.x),
          y: Math.abs(e.clientY - (origin.y + lastTranslation.y))
        }
      });
      props.updateValuesForSlide(props.index, 0, Math.abs(e.clientX - origin.x));
    }
  };

  const handleMouseUp = useCallback(() => {
    if (isDragging) {
      const { translation } = dragInfo;
      setDragInfo({
        ...dragInfo,
        isDragging: false,
        lastTranslation: { x: props.left, y: translation.y },
        origin: { x: props.left, y: 0 }
      });
    }
    props.finishedSettingValues();
  }, [dragInfo, isDragging, props.left]);

  //   const left = isDragging ?

  useEffect(() => {
    const eventListener = () => {
      if (isDragging) {
        handleMouseUp();
      }
    };
    document.addEventListener("mouseup", eventListener);
    return () => {
      document.removeEventListener("mouseup", eventListener);
    };
  }, [isDragging]);

  return (
    <div
      className="MultiPartSliderHandle"
      style={{ left: `${props.left - 26}px` }}
      key={props.item.label}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      // onMouseLeave={handleMouseUp}
      onMouseUp={handleMouseUp}
    >
      <div className="handleCircle" />
      <svg focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="22" height="40">
        <path
          fill={props.item.color}
          d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
        ></path>
      </svg>
      <div className="valueLabel">{props.item.value}</div>
    </div>
  );
};
